import script from "./returnorder.vue?vue&type=script&setup=true&lang=js"
export * from "./returnorder.vue?vue&type=script&setup=true&lang=js"

import "./returnorder.vue?vue&type=style&index=0&id=8721a1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8721a1f4"]])

export default __exports__